<template>
    <div class="page-wrapper" v-if="$route.name!=='Set Password' && $route.name!=='Reset Password'">
        <div class="">
            <Header v-if="showShellLayout" />
        </div>
        <div class="page-body-wrapper">
            <Sidebar v-if="showShellLayout" class="page-sidebar" />
            <div class="page-body">
                <router-view />
            </div>
            <Footer v-if="showShellLayout" />
            <!-- END PAGE CONTENT -->
        </div>
        <!-- END MAIN CONTENT -->
    </div>
    <div class="page-wrapper" v-if="$route.name=='Set Password' || $route.name=='Reset Password'">
        <div class="page-body">
            <router-view />
        </div>
    </div>
    <AppChatbot v-if="!$route.meta?.hideLayout && !isChecklistPopupMode" />
</template>

<script>
    import Header from "@/layouts/header/Header.vue"
    import Sidebar from '@/layouts/sidebar/Sidebar.vue';
    import Footer from "@/layouts/footer/footer.vue";
    import AppChatbot from "@/layouts/ChatBot/chatbot.vue";
    import { initShellLayoutWhenReady } from '@/helpers/shellLayout';
    //import minJs from "@/assets/CustomJs/jquery-3.4.1.min.js"
    //import boostrp from "@/assets/CustomJs/bootstrap.min.js"
    //import customjs from "@/assets/CustomJs/front.js"

    export default {
        name: 'LayoutName',
        components: {
            Header,
            Sidebar, Footer, AppChatbot
        },
        created() {
            
            //alert(this.$route.name);
            //var scripts = [
            //    "https://portal.orbistream.com/assets/js/front.js"

            //];
            //scripts.forEach(script => {
            //    let tag = document.createElement("script");
            //    tag.setAttribute("src", script);
            //    document.head.appendChild(tag);

            //});
        },
        mounted() {
            this.scheduleShellLayoutSync();
        },
        watch: {
            showShellLayout(visible) {
                if (visible) {
                    this.scheduleShellLayoutSync();
                }
            }
        },
        methods: {
            scheduleShellLayoutSync() {
                this.$nextTick(() => {
                    initShellLayoutWhenReady();
                });
            }
        },
        computed: {
            isChecklistPopupMode() {
                return this.$route?.path === '/onboardinglist' && this.$route?.query?.checklistPopup === 'true';
            },
            showShellLayout() {
                // Re-evaluate when route changes so shell appears after client-side post-login navigation.
                void this.$route?.fullPath;
                const token = localStorage.getItem("access_token");
                return token != null &&
                    token !== '' &&
                    this.$route.name !== 'login' && this.$route.name !=='account/resetpassword' && 
                    !this.$route.meta?.hideLayout &&
                    !this.isChecklistPopupMode;
            }
        }

    }
</script>